// Converts a "HH:MM" wall-clock time (and optional day-of-week list) from the
// timezone it was created in to the viewer's current timezone for display purposes.
// The stored time/days are never mutated - only the returned display values change.
export const UseConvertScheduleTimezone = (time, days, fromTimeZone, toTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone) => {
    if (!time || !fromTimeZone || fromTimeZone === toTimeZone) {
        return { time, days };
    }

    const getOffsetMinutes = (timeZone, referenceDate) => {
        const parts = new Intl.DateTimeFormat('en-US', {
            timeZone,
            hour12: false,
            year: 'numeric', month: '2-digit', day: '2-digit',
            hour: '2-digit', minute: '2-digit', second: '2-digit'
        }).formatToParts(referenceDate).reduce((acc, part) => {
            acc[part.type] = part.value;
            return acc;
        }, {});

        const asUTC = Date.UTC(
            parts.year, parts.month - 1, parts.day,
            parts.hour === '24' ? 0 : parts.hour, parts.minute, parts.second
        );

        return (asUTC - referenceDate.getTime()) / 60000;
    };

    const [hours, minutes] = time.split(':').map(Number);
    const referenceDate = new Date();
    const diffMinutes = getOffsetMinutes(toTimeZone, referenceDate) - getOffsetMinutes(fromTimeZone, referenceDate);

    let totalMinutes = hours * 60 + minutes + diffMinutes;
    let dayOffset = 0;

    if (totalMinutes < 0) {
        dayOffset = -1;
        totalMinutes += 1440;
    } else if (totalMinutes >= 1440) {
        dayOffset = 1;
        totalMinutes -= 1440;
    }

    const newHours = String(Math.floor(totalMinutes / 60)).padStart(2, '0');
    const newMinutes = String(totalMinutes % 60).padStart(2, '0');

    const convertedDays = dayOffset !== 0 && Array.isArray(days)
        ? days.map(day => String((((parseInt(day) + dayOffset) % 7) + 7) % 7))
        : days;

    return { time: `${newHours}:${newMinutes}`, days: convertedDays };
}
